'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _format = require('@marmalade/format');

// Takes hours and minutes, and optional am/pm formatting option, returns string of hours and minutes - 13:30 || 01:30 pm
var formatTime = function formatTime(hours, minutes) {
  var am = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var h = hours;
  var m = minutes;
  var formatting = 'am';
  if (am) {
    if (hours > 13) {
      h = hours - 12;
      formatting = 'pm';
    }
  }
  m = (0, _format.prefixZero)(m);
  return h + ':' + m + (am ? ' ' + formatting : '');
};
exports.default = formatTime;